import httpClient from '@src/services/http.service'

export const state = {
  pageData: [],
  error: '',
}

export const actions = {
  init: ({ commit }) => {
    httpClient.get('pages/5fe319e4c1478823bac06387')
    .then(response => {
      commit('SET_PAGE_DATA', response.data)
    })
    .catch(error => {
      commit('SET_ERROR', error.message)
    })
  },
}

export const mutations = {
  SET_PAGE_DATA: (state, pageData) => {
    state.pageData = pageData
  },
  SET_ERROR: (state, error) => {
    state.error = error
  },
}

export const getters = {
  pageData: state => state.pageData,
}

export default {
  state,
  getters,
  actions,
  mutations,
}
